import clsx from 'clsx';

/**
 * Accessible text / number input with label + error state
 *
 * Props: label, error, type, name, value, onChange, className, …rest
 */
export default function Input({
  label,
  error = '',
  className = '',
  ...rest
}) {
  const id = rest.id ?? rest.name;

  return (
    <div className="flex flex-col gap-unit-sm">
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-charcoal">
          {label}
        </label>
      )}

      <input
        id={id}
        className={clsx(
          'w-full rounded border px-3 py-2 shadow-sm',
          'focus:outline-none focus:ring-2 focus:ring-dominant-purple',
          error ? 'border-red-500' : 'border-light-gray',
          className,
        )}
        {...rest}
      />

      {error && <span className="text-xs text-red-500">{error}</span>}
    </div>
  );
}
